import { Routes } from '@angular/router';
import { MainLayoutComponent } from './main-layout/main-layout.component';
import { NotFoundComponent } from './main-layout/notfound/notfound.component';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./main-layout/home/home.component').then(m => m.HomeComponent)
      }
    ]
  },
  {
    path: '404-notfound', component: NotFoundComponent
  },
  {
    path: '**', redirectTo: '/404-notfound'
  }
];
